<div class='wrapper-ecg custom-scroll'>
    <canvas
        #ecg
        width='800'
        height='400'
    ></canvas>
</div>
